import { useEffect, useRef } from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useTransition } from '../../context/TransitionContext.tsx';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import './CtaSection.scss';

gsap.registerPlugin(ScrollTrigger);

interface CtaSectionProps {
  title?: string;
  buttonText?: string;
  buttonLink?: string;
  backgroundImage?: string;
}

function CtaSection({
  title = "Sei interessato ai servizi?",
  buttonText = "Contatti",
  buttonLink = "/contatti",
  backgroundImage = "/sfondi/sfondo1.png"
}: CtaSectionProps) {
  const { navigateWithTransition } = useTransition();
  const ctaTitleRef = useRef<HTMLHeadingElement>(null);

  const animateSplitText = (element: HTMLElement) => {
    const text = element.textContent || '';
    element.innerHTML = text
      .split('')
      .map(char => char === ' ' ? ' ' : `<span class="split-char">${char}</span>`)
      .join('');

    const chars = element.querySelectorAll('.split-char');
    gsap.fromTo(chars,
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        stagger: 0.03,
        ease: "power3.out",
        scrollTrigger: {
          trigger: element,
          start: "top 80%",
          toggleActions: "play none none none"
        }
      }
    );
  };

  useEffect(() => {
    if (ctaTitleRef.current) {
      animateSplitText(ctaTitleRef.current);
    }

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <Box
      className="cta-section-agricola"
      style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('${backgroundImage}')`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <Container maxWidth="md">
        <Typography variant="h3" className="cta-title-agricola split-text" ref={ctaTitleRef}>
          {title}
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigateWithTransition(buttonLink)}
          className="btn-primary-agricola"
        >
          {buttonText}
        </Button>
      </Container>
    </Box>
  );
}

export default CtaSection;
